import React from 'react'

import Label from 'components/general/Label';
import SportCode from 'components/common/SportCode';
import { isParalympic, CompetitionFromStore } from 'helpers/utils'
import Competitor from 'components/presentation/Competitor';
import { NocMemo as Noc } from 'components/presentation/Noc';
import { appealIcon } from "../common/Icons"
import { ColumnName, ColumnNoc, ColumnResult } from "components/common/TableColumns"


export function ColumnHeatRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Heat',
        headerClassName: "text-end w-5 align-middle",
        id: 'HeaderHeat',
        columns: [
            ColumnHeat({ remove: true })
        ]
    }
}


export function ColumnHeat({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderHeat',
    accessor = 'sortOrder',
    remove = false,
    qual = false,
    enableRowSpan = false,
    rowSpanType = 'cell' //accessor de donde toma el valor para hacer el rowspan
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Heat',
            remove: remove,
            enableRowSpan: enableRowSpan,
            rowSpanType: rowSpanType,
            Cell: (props) => {
                return (qual ? props.cell.row.original?.heat : props.cell.row.original?.code)
                //return ("ValorCell")
            }
        }
    )
}


export function ColumnLaneAColspan({ isMobile = false }) {
    return {
        id: 'HeaderLaneA',
        Header: <Label data="HeaderLaneA" />,
        headerClassName: "text-center",
        columns: [
            ColumnBibLane({ remove: true, disableSort: true, lane: "A" }),
            ColumnNocLane({ remove: true, disableSort: true, lane: "A" }),
            ColumnNameLane({ remove: true, disableSort: true, lane: "A" }),
        ]
    }
}


export function ColumnLaneBColspan({ isMobile = false }) {
    const bibLane = [ColumnBibLane({ remove: true, disableSort: true, lane: "B" })]
    return {
        id: 'HeaderLaneB',
        Header: <Label data="HeaderLaneB" />,
        headerClassName: "text-center",
        columns: [
            ColumnBibLane({ remove: true, disableSort: true, lane: "B" }),
            ColumnNocLane({ remove: true, disableSort: true, lane: "B" }),
            ColumnNameLane({ remove: true, disableSort: true, lane: "B" }),
        ]
    }
}


export function ColumnBibLane({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'HeaderBibNoR',
    lane = "A"
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: lane === 'A' ? 'bibA' : 'bibB',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: lane === 'A' ? 'BibA' : 'BibB',
            Cell: (props) => {
                const row = props.cell.row.original
                return lane === 'A' ? props.cell.row.original?.bibA : props.cell.row.original?.bibB;
            }
        }
    )
}


export function ColumnNocLane({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start cell w-5',
    label = 'HeaderNOC',
    lane = 'A'
}) {
    const competition = CompetitionFromStore();
    if (isParalympic(competition) && label === 'HeaderNOC') {
        label = 'HeaderNPC';
    }
    return (
        {
            Header: <Label data={label} />,
            id: lane === 'A' ? 'NOC_A' : 'NOC_B',
            accessor: lane === 'A' ? 'participantA.organisation.code' : 'participantB.organisation.code',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            Cell: (props) => {
                const row = props.cell.row.original
                let data = lane === 'A' ? row?.participantA?.organisation : row?.participantB?.organisation
                return (<Noc {...data} />)
            }
        }
    )

}


export function ColumnNameLane({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start',
    label = 'HeaderName',
    hideNoc = false,
    noLink = false,
    showGuide = false,
    lane = 'A'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => {
                const out = lane === 'A' ? props?.participantA?.name?.toUpperCase() : props?.participantB?.name?.toUpperCase();
                return out;
            },
            id: lane === 'A' ? 'NameA' : 'NameB',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            hideNoc: hideNoc,
            noLink: noLink,
            showGuide: showGuide,
            Cell: (props) => {
                const row = props.cell.row.original
                let data = lane === 'A' ? row?.participantA : row?.participantB
                return (<Competitor
                    hidePicture={true}
                    hideNoc={hideNoc}
                    nolink={noLink}
                    {...data}
                />)
            }
        }
    )
}


export function ColumnResultLane({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderLaneA',
    lane = 'A'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => {
                const er = props?.extendedResults?.find(er => er?.er_pos === lane && er?.er_code === 'TIME')
                return er && er?.er_sortorder ? er?.er_sortorder : er && er?.er_value && er?.er_value === 'Fall' ? 900 : er && er?.er_value ? er?.er_value : 1000;
            },
            id: lane === 'A' ? 'RessultA' : 'RessultB',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            Cell: (props) => {
                const row = props.cell.row.original
                const er = row?.extendedResults?.find(er => er?.er_pos === lane && er?.er_code === 'TIME')
                let out = er && er?.er_value === 'Fall' ? <><SportCode discipline='CLB' entity='@IRM' code='Fall' abbr={true} /></> : er?.er_value ? <>{er?.er_value}</> : <></>
                return out;
            }
        }
    )
}

export function ColumnResultRR({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTime',
    remove = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Result',
            remove: remove,

            Cell: (props) => {
                const row = props.cell.row.original;
                const irm = row?.resultType === 'IRM' && row?.resultIrm ? <SportCode discipline='CLB' entity='@IRM' code={row.resultIrm} abbr={true} /> : '';
                const appeal = row?.unchecked === 'Y' ? appealIcon : '';
                const result = row?.resultType !== 'IRM' ? row?.resultData ? row.resultData : '' : '';
                const record = row?.recordIndicators ? row.recordIndicators?.filter(record => record?.ri_order === 1)?.map(val => ((val?.ri_equalled === 'Y' ? '=' : '') + val.ri_recordtype)) : '';
                let rrResult = ''
                let rrRecord = ''
                let rerun = '';
                if (row?.rerun === 'Y') {
                    rrResult = row?.extendedResults?.find(er => er?.er_code === 'ORIGINAL')?.er_value;
                    if (rrResult === 'Fall') {
                        rrResult = <SportCode discipline='CLB' entity='@IRM' code={'Fall'} abbr={true} />;
                    } else if (rrResult === 'FS') {
                        rrResult = <SportCode discipline='CLB' entity='@IRM' code={'FS'} abbr={true} />;
                    }
                    rrRecord = row?.extendedResults?.find(er => er?.er_code === 'ORIGINAL_RECORD');
                    rrRecord = rrRecord ? (rrRecord?.er_pos === 'Y' ? '=' : '') + rrRecord?.er_value : '';
                    rerun = <><p className="text-end">{'RR'} {rrResult} {rrRecord}</p></>
                }

                let out = <>
                    {appeal}{irm}{result} {record}
                </>

                if (row?.rerun === 'Y') {
                    out = <>
                        {appeal}{rrResult} {rrRecord}
                        <p className="text-end">{'RR'} {irm}{result} {record}</p>
                    </>
                }

                return (<>{out}</>)
            },
        }
    )
}


export function ColumnLane({
    disableSort = true,
    className = 'text-center',
    headerClassName = 'text-center w-10',
    label = 'HeaderLane',
    remove = false

}) {
    return ({
        Header: <Label data={label} />,
        className: className,
        headerClassName: headerClassName,
        disableSortBy: disableSort, //habilita poder ordenar
        id: 'Lane',
        remove: remove,
        accessor: 'lane',

    })

}


export function ColumnLuckyLoserColSpan({ }) {
    return {
        id: 'LuckyLoser',
        Header: <Label data="HeaderCurrentLuckyLoser" />,
        headerClassName: "text-start",
        columns: [
            ColumnNoc({ remove: true, disableSort: true, className: 'text-start w-5', headerClassName: 'text-start w-5' }),
            ColumnName({ remove: true, disableSort: true, hideNoc: true })
        ]
    }

}


export function ColumnResultRowSpan({ }) {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Result',
        headerClassName: "text-end w-20 align-middle",
        id: 'HeaderResult',
        columns: [
            ColumnResult({ remove: true, label: 'HeaderFastestTime' })
        ]
    }

}